/* src/app/app.component.scss */
@font-face {
  font-family: Viga;
  src: url("./media/Viga-Regular.ttf");
}
::ng-deep .mat-mdc-form-field {
  --mat-form-field-container-text-line-height: 26px;
}
::ng-deep .mat-mdc-unelevated-button:not(:disabled).header-button {
  background-color: white !important;
  color: var(--primary) !important;
}
::ng-deep .mdc-button {
  font-size: 18px !important;
}
::ng-deep .mdc-button:focus {
  border: 2px solid rgba(0, 0, 0, 0.5);
  opacity: 0.9;
}
::ng-deep .mat-mdc-form-field-subscript-wrapper:has(.mat-mdc-form-field-hint),
::ng-deep .half-fields .mat-mdc-form-field-subscript-wrapper {
  margin: 0 0 14px 0;
}
@media screen and (max-width: 625px) {
  ::ng-deep .mat-mdc-form-field-subscript-wrapper:has(.mat-mdc-form-field-hint),
  ::ng-deep .half-fields .mat-mdc-form-field-subscript-wrapper {
    margin: 0 0 28px 0;
  }
}
::ng-deep .mat-mdc-form-field-hint-wrapper {
  padding: 0 0 0 16px !important;
}
::ng-deep .mat-mdc-select-panel {
  border-radius: 0 0 24px 24px !important;
  padding: 0 !important;
}
::ng-deep .mat-stepper-vertical,
::ng-deep .mat-stepper-horizontal {
  background-color: transparent !important;
}
::ng-deep .cdk-overlay-pane .mat-mdc-dialog-container {
  --mat-dialog-container-color: #fbfaed;
}
::ng-deep .cdk-overlay-pane .mat-mdc-dialog-container .mdc-dialog__container .mdc-dialog__surface {
  padding: 24px 24px 12px 24px;
  --mat-dialog-container-shape: 24px;
}
::ng-deep .cdk-overlay-pane .mat-mdc-dialog-container .mdc-dialog__container .mdc-dialog__surface .mat-mdc-dialog-title,
::ng-deep .cdk-overlay-pane .mat-mdc-dialog-container .mdc-dialog__container .mdc-dialog__surface .mdc-dialog__title {
  padding: 0;
  --mat-dialog-subhead-font: Viga;
  --mat-dialog-subhead-color: #1b1c15;
  --mat-dialog-subhead-line-height: normal;
  --mat-dialog-subhead-tracking: normal;
}
::ng-deep .cdk-overlay-pane .mat-mdc-dialog-container .mdc-dialog__container .mdc-dialog__surface .mat-mdc-dialog-title .dialog-title,
::ng-deep .cdk-overlay-pane .mat-mdc-dialog-container .mdc-dialog__container .mdc-dialog__surface .mdc-dialog__title .dialog-title {
  margin: 0 !important;
}
::ng-deep .cdk-overlay-pane .mat-mdc-dialog-container .mdc-dialog__container .mdc-dialog__surface .mdc-dialog__title::before {
  height: 0px !important;
  content: unset !important;
}
::ng-deep .cdk-overlay-pane .mat-mdc-dialog-container .mdc-dialog__container .mdc-dialog__surface .mat-mdc-dialog-content,
::ng-deep .cdk-overlay-pane .mat-mdc-dialog-container .mdc-dialog__container .mdc-dialog__surface .mdc-dialog__content {
  margin: 16px 0 24px 0;
  padding: 16px 0 0 0 !important;
  --mat-dialog-supporting-text-size: 14px;
  --mat-dialog-supporting-text-line-height: normal;
  --mat-dialog-supporting-text-tracking: normal;
  --mat-dialog-supporting-text-color: black;
}
::ng-deep .cdk-overlay-pane .mat-mdc-dialog-container .mdc-dialog__container .mdc-dialog__surface .mdc-dialog__actions,
::ng-deep .cdk-overlay-pane .mat-mdc-dialog-container .mdc-dialog__container .mdc-dialog__surface .mat-mdc-dialog-actions {
  padding: 0;
  display: flex;
}
/*# sourceMappingURL=app.component.css.map */
